export const DecimalRoundTypeEnum = {
    Cut: 0,
    RoundUp: 1,
    Round: 2,
    AwayFromZero: 3,
};